export const ONCE_PER_DAY = 86400;
export const ONCE_PER_EIGHT_HOURS = 28800;

export const REVALIDATION_TAGS = {
  // Contentful
  page: encodeURIComponent("page"),
  siteinfo: encodeURIComponent("siteinfo"),
  keyValue: encodeURIComponent("keyValue"),
  dictionary: encodeURIComponent("dictionary"),
  campaign: encodeURIComponent("campaign"),
  editorialPage: encodeURIComponent("editorialPage"),
  landingPage: encodeURIComponent("landingPage"),
  sideMenu: encodeURIComponent("sideMenu"),
  header: encodeURIComponent("header"),
  store: encodeURIComponent("store"),
  productPageInfo: encodeURIComponent("productPageInfo"),
  navigation: encodeURIComponent("navigation"),
  navigationLink: encodeURIComponent("navigationLink"),
  form: encodeURIComponent("form"),
  footerBanner: encodeURIComponent("footerBanner"),
  pageBySlug: (slug: string) => encodeURIComponent(`page:${slug}`),
  pageByType: (type: string) => encodeURIComponent(`pageType:${type}`),
  accordionRow: encodeURIComponent("accordionRow"),
  accordion: encodeURIComponent("accordion"),
  checkoutDelivery: encodeURIComponent("checkoutDelivery"),
  block: encodeURIComponent("block"),
  splash: encodeURIComponent("splash"),
  // Loop
  loopAll: encodeURIComponent("loop:all"),
  flags: encodeURIComponent("loop:flags"),
  productById: (id: string) => encodeURIComponent(`loop:productById:${id}`),
  productByMainURL: (url: string) =>
    encodeURIComponent(`loop:productByMainUrl:${url}`),
  brandByCode: (code: string) => encodeURIComponent(`loop:brandByCode:${code}`),
  designerByCode: (code: string) =>
    encodeURIComponent(`loop:designerByCode:${code}`),
  categoryByCode: (code: string) =>
    encodeURIComponent(`loop:categoryByCode:${code}`),
} as const;
